import { Button, FormInstance, Row } from "antd";
import { useUpdate } from "../hooks/useUpdate";
import { usePermissions } from "../../../../../../../../../../../lib/hooks/usePermissions";
import { useMemo } from "react";

type FormButtonsProps = {
  id: string | null;
  form: FormInstance;
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  closeAfterSave: () => void;
  closeModal: () => void;
};

export const FormButtons = ({
  id,
  form,
  isLoading,
  setIsLoading,
  closeAfterSave,
  closeModal,
}: FormButtonsProps) => {
  const { hasAccessByController } = usePermissions("ImpoundActivities");

  const { onSave } = useUpdate(id, form, setIsLoading, closeAfterSave);

  const isCancelDisabled: boolean = useMemo(() => {
    return hasAccessByController("Modify") ? isLoading : false;
  }, [hasAccessByController, isLoading]);

  return (
    <Row className="justify-end mt-6 mb-1">
      {hasAccessByController("Modify") && (
        <Button
          shape="round"
          type="primary"
          className="mr-2"
          onClick={onSave}
          loading={isLoading}
        >
          Save
        </Button>
      )}
      <Button shape="round" onClick={closeModal} disabled={isCancelDisabled}>
        Cancel
      </Button>
    </Row>
  );
};
